// ESM-Modul fuer den Websocket-/HTTP-Client der Kasse (frueher
// lib/scripts/pos/netcomm/CLS_CRunClient.js, das LETZTE klassische Skript der
// Anwendung - alles andere war laengst im Buendel).
//
// Originalquelltext unveraendert uebernommen; geaendert sind nur:
//   1. Import/Export (ESM),
//   2. die beiden eval-Aufrufe -> window.__posLegacyEval.call(this, code).
//
// Zu 2.: ES-Module sind IMMER strikt, die vom Zentralserver geschickten
// Nutzlasten sind aber alter nicht-strikter Code. Der nicht-strikte Scope
// bleibt darum in einem winzigen klassischen Skript zurueck
// (lib/scripts/pos/netcomm/legacy-eval.js) - dort steht auch, was dabei
// exakt erhalten bleibt und was die einzige Abweichung ist.
//
// FUND beim Portieren, ABSICHTLICH NICHT REPARIERT: sendData ist zweimal
// definiert (Websocket-Fassung, dann HTTP-Fassung). Die zweite ueberschreibt
// die erste zur Ladezeit, die erste ist also fuer JEDEN Aufrufer
// unerreichbar. Sie bleibt zeichengleich stehen - Aufraeumen waere eine
// eigene, eigens zu pruefende Aenderung.

function CRunClient() {
    this.callback = null;

}

CRunClient.prototype.init = function (address, port) {
    var me = this;
    if (!address) {
        address = location.hostname;
    }
    if (!port) {
        port = location.port;
    }

    this.socket;
    //var url = window.location.href;
    if (location.protocol === 'https:') {
        var prot = "wss://"; // page is secure
    } else {
        prot = "ws://";
//prot = "http://";
    }
    var host = prot + address + (port?":" + port:"") + "/wskasse/"; // SET THIS TO YOUR SERVER
    try {
        this.socket = new WebSocket(host);
        var t = 'WebSocket - status ' + this.socket.readyState;
        console.log(t);
        log.add(t);
        this.socket.onopen = function (msg) {
            console.log("Welcome - status " + this.readyState);
        };
        var splittedstr = "";
        this.socket.onmessage = function (msg) {
            console.log("Received: " + msg.data);
            if (typeof msg.data != 'string') {
                me.sendWebsocketData(null, "RPL:OK");
                return;
            }
            //	if (msg.startsWith("HEX:")){
            //		msg = msg.substring(4);
            if (msg.data.startsWith("MSG:")) {
                me.sendWebsocketData(null, "RPL:OK");

                if (msg.data.endsWith("::::")) {
                    splittedstr = splittedstr + msg.data.substr(4, msg.data.length - 11);
                    if (!(msg.data.endsWith("999::::"))) {
                        return;
                    }
                    var d = "MSG:" + splittedstr;
                    splittedstr = "";
                    var ind = d.indexOf(' ');
                    if (ind == -1) {
                        ind = d.length;
                    }
                    var msgs = [];
                    msgs[0] = d.substring(0, ind);
                    msgs[1] = d.substring(ind + 1);

                } else {
                    msgs = []; //msg.data.split(" ");
                    var ind = msg.data.indexOf(' ');
                    if (ind == -1) {
                        ind = msg.data.length;
                    }
                    msgs[0] = msg.data.substring(0, ind);
                    msgs[1] = msg.data.substring(ind + 1);
                }
                // ENTFERNT beim Buendeln (25.8.2026), weil NACHWEISLICH wirkungslos:
                // hier stand "msg.data = msgs[0];". MessageEvent.data ist eine
                // reine Getter-Eigenschaft. Im nicht-strikten Modus verpuffte die
                // Zuweisung STILL (im Browser geprueft: der Wert bleibt der
                // urspruengliche, kein Fehler) - im ES-Modul, das immer strikt
                // ist, wirft dieselbe Zeile bei JEDER Websocket-Nachricht einen
                // TypeError. Weglassen erhaelt das Verhalten exakt: Zeile ~207
                // liest msg.data spaeter wieder und bekam schon bisher die
                // UNVERAENDERTE Nachricht. Sie "zu reparieren" (also die
                // Zuweisung wirksam zu machen) waere die eigentliche Regression.
                switch (msgs[0]) {
                case "MSG:hasemail":
                    if (POS.sessions.currentSession) {
                        // "var" ergaenzt beim Buendeln (25.8.2026): hier stand
                        // ein undeklariertes "s = ...". Nicht-strikt legte das
                        // still eine GLOBALE an, im ES-Modul (immer strikt)
                        // waere es ein ReferenceError - und zwar ausgerechnet
                        // auf dem hasemail-Pfad, der nur beim Eintreffen einer
                        // Nachricht laeuft. Die Globale liest nirgends jemand
                        // (im ganzen Baum geprueft), zwei Zeilen weiter wird
                        // sie sofort verbraucht.
                        var s = POS.sessions.currentSession;
                        var main = POS.sessions.openSessions[s];
                        main.InfoIcons.highlightIcon("email", s);
                        main.InfoIcons.showNewMessagePopup(s);
                    }
                    break;
                case "MSG:importingdata":
                    POS.hourGlass.show("Importiere Daten!");
                    break;
                case "MSG:importdata":
                    var di = new CDataImport();
                    POS.DataImport = di;
                    di.importFile = "var/db/import/MasterData_LE";
                    di.executeImport(di);
                    break;
                case "MSG:importdataend":
                    POS.hourGlass.hide();
                    POS.events.unlock();
                    break;
                case "MSG:generatereports":
                    var de = new CDataExport();
                    POS.DataExport = de;
                    if (msgs[1]) {
                        var days = msgs[1].split(" ");
                        de.generateandExportReports(de, 0, days[0], days[1])
                    } else {
                        de.generateandExportReports(de, 0);
                    }
                    break;
                case "MSG:scanner":
                    var barcode = msgs[1];
                    var barcodeReader = new CBarcodeReader();
                    barcodeReader.processInput(barcode, POS, "screen");
                    break;
                case "MSG:executejs":

                    window.__posLegacyEval.call(this, fs.readFileSync(msgs[1]));
                    break;
                case "MSG:execute":
                    //var data = JSON.parse(msgs[1]);
                    //var data = decodeURIComponent(msgs[1]);
                    /*      } else {
                    data = body;
                    }*/
                    window.__posLegacyEval.call(this, data);
                    break;
                case "MSG:printerstatus":
                    var status = msgs[1];
                    if (status == "1") {
                        POS.Cashbox.printerstatus = true;
                    } else {
                        POS.Cashbox.printerstatus = false;
                    }
                    POS.Cashbox.watchdog(POS.Cashbox);
                    break;
                case "MSG:cashboxstatus":
                    var data = msgs[1];
                    POS.Cashbox.Printer.status = data.split('');
                    POS.Cashbox.watchdog(POS.Cashbox);
                    break;
                case "MSG:requestbunch":
                    var data = JSON.parse(msgs[1]);
                    var prodids = data["prodids"];
                    var ip = data["ip"];
                    var T = new CBonTransaction();
                    $.when(T.getBFCsforSlave(prodids)).then(function (bfcs) {
                        //res.end(JSON.stringify(bfcs));
                        var data = {
                            "host": ip,
                            "port": 9000,
                            "data": "addbunch " + JSON.stringify({
                                "bfcs": bfcs
                            })
                        }
                        var url = "request.php";
                        $.when(new CRunClient().sendDataAsync(null, null, null, null, 0, null, url, data)).then(function (data, error) {
                            if (data) {}
                            else if (error) {
                                log.add(4, "Fail", "Bunches could not be sent!");
                            }
                        });

                    });
                    break;
                case "MSG:addbunch":
                    try {
                        log.add(4, "INFO", "Received addbunch", String(msgs[1]).substring(0, 80));
                        var b = JSON.parse(msgs[1]);
                        var bfcs = b["bfcs"];
                        var iterator = function it(i) {
                            if (i < bfcs.length) {
                                var data = bfcs[i];
                                var userId = data["userid"];
                                var T = new CBonTransaction();
                                $.when(T.openBon(userId)).then(function (bonid) {
                                    var currentBon = data["bon"];
                                    var prod = data["prod"];
                                    $.when(T.addBunchFromMaster(bonid, currentBon, prod.sum, prod.bunchtype, prod.qty, prod.barcode)).then(function (bonid) {
                                        iterator(i + 1);
                                    });
                                });
                            } else {
                                return;
                            }
                        }
                        iterator(0);
                    } catch (e) {
                        log.add(4, "ERROR", "", JSON.stringify(e));
                    }
                    break;
                default:

                }
                return;
            } else {
                msg = Buffer.from(msg.data, "hex");
            }
            if (me.callback)
                me.callback(msg);
        };
        this.socket.onclose = function (msg) {
            POS.message.show("Ein Prozess für Bankomat läuft nicht! Bitte Kasse neu starten!", "warning", "OK");
            setTimeout(function () {
                me.init(address, port)
            }, 30000);
            console.log("Disconnected - status " + this.readyState);
        };
    } catch (ex) {
        console.log(ex);
        log.add(ex);
        setTimeout(function () {
            me.init(address, port)
        }, 30000);
    }

    /* test///////////////////////////////////////////////////
    function test (){

    var bfcs='{"bfcs":[{"userid":"324","bon":[{"BONE_ID":"3351026","BON_ID":"1721482","Type":"BFS","Qty":"1.0","Amount":"29.6","';


    var data={      "host": "127.0.0.1",
    "port": 9000,
    "data":"addbunch "+bfcs,
    }
    var url =  "request.php";
    $.when(new CRunClient().sendDataAsync(null, null, null, null, 0, null, url, data)).then(function(data,error){
    if (data) {
    } else if (error){
    log.add(4, "Fail", "Bunches could not be sent!");
    }
    });
    }
    setTimeout(function(){test()},5000);

     ***************************************************************************/

}

CRunClient.prototype.sendWebsocketData = function (callback, DataToSend, counter, defret, expectedreplies) {

    try {
        if (Buffer.isBuffer(DataToSend)) {
            DataToSend = DataToSend.toString('hex');
            //            DataToSend = "HEX:"+DataToSend;
        }
        this.socket.send(DataToSend + '$');
        console.log('Sent: ' + DataToSend);
        if (callback) {
            this.callback = callback;
        }
        if (callback && expectedreplies === -1) {
            setTimeout(function () {
                callback()
            }, 200);
        }
    } catch (ex) {
        console.log(ex);
        //		init();

    }
}

CRunClient.prototype.endWebsocket = function () {

    if (this.socket != null) {
        console.log("Goodbye!");
        this.socket.close();
        this.socket = null;
    }
}

//zwecks Rückwärtskomp.
/*CRunClient.prototype.client = {
end: function(){},
}*/

/*
CRunClient.prototype.sendData = function(address, port, callback, DataToSend, counter, defret, expectedreplies) {

this.address=address;
this.port=port;
POS.hourGlass.show();

if (!(expectedreplies)) {
var expectedreplies=1;
}

var me = this;
me.callback = callback;
var isbin = false;
if (Buffer.isBuffer(DataToSend)){
DataToSend=  DataToSend.toString('hex');
isbin=true;
}

if (!counter)
counter = 0;

$.ajax({
type: "GET",
url: "/cgi/netconnect.cgi",
data: {
"host": address,
"port": port,
"message": DataToSend,
"isbin": (isbin?"true":"false"),
"expectedreplycount": expectedreplies
},
cache: false,
success: function(responsetext){
if (responsetext.indexOf("NOK")===0) {
console.log('error from server: '+responsetext);
if (callback) callback(null,true);
} else {
if (isbin){
if (callback) callback(Buffer.from(responsetext, "hex"));
}else {
if (callback) callback(responsetext);
}
}

},
error: function(xhr) {
console.log('error from server: '+xhr.responseText);
if (callback) callback(null,true);
}
})

}
 */
CRunClient.prototype.sendDataAsync = function (address, port, callback, DataToSend, counter, defret, url, data) {

    this.address = address;
    this.port = port;

    var defret = $.Deferred();

    if (!address) {
        this.address = location.hostname;
    }
    if (!port) {
        this.port = location.port;
    }

    POS.hourGlass.show();

    if (!(url)) {
        url = "/cgi/netconnect.php";
    }

    var me = this;
    me.callback = callback;
    var isbin = false;
    if (Buffer.isBuffer(DataToSend)) {
        DataToSend = DataToSend.toString('hex');
        isbin = true;
    }

    if (!counter)
        counter = 0;

    var str = data.data;
    var isMessage = false;

    if (!(data)) {
        data = {
            "host": address,
            "port": port,
            "message": DataToSend,
            "isbin": (isbin ? "true" : "false"),
        }
        str = DataToSend;
        isMessage = true;
    }

    var chunk = 1200;

    var len = str.length;
    var counter = 99;
    if (len <= chunk) {
        counter = 0;
    }

    function iterator(written) {
        if (written < len) {
            var senddata = str.substr(written, chunk);
            if (counter > 0) {
                if ((written + chunk) >= len) {
                    counter = 998;
                }
                counter = counter + 1;
                var postfix = String(counter) + "::::"
            } else {
                postfix = "";
            }
            //var postfix=counter?String(counter)+"::::":"";
            if (isMessage) {
                data["message"] = senddata + postfix;
            } else {
                data["data"] = senddata + postfix;
            }
            console.log("Send:" + senddata + postfix);
            var responsetext = $.ajax({
                type: "POST",
                url: url,
                data: data,
                cache: false,
                success: function (response) {
                    written = written + chunk;
                    //setTimeout(function(){iterator(written)}, 30);
                    iterator(written);
                },
                error: function (xhr) {
                    defret.resolve(null, "NOK: " + xhr.statusText);
                    POS.hourGlass.hide();
                    log.add('error from server: ' + xhr.statusText);

                }

            });
        } else {
            defret.resolve("OK");
            POS.hourGlass.hide();
        }

    }
    iterator(0);
    //POS.hourGlass.hide();
    return defret.promise();

}

CRunClient.prototype.sendData = function (address, port, callback, DataToSend, counter, defret, url, data, type, headers) {

    this.address = address;
    this.port = port;

    if (!address) {
        this.address = location.hostname;
    }
    if (!port) {
        this.port = location.port;
    }
	
	if (!type) {
        type = "POST";
    }

    POS.hourGlass.show();

    if (!(url)) {
        url = "/cgi/netconnect.php";
    }

    var me = this;
    me.callback = callback;
    var isbin = false;
    if (Buffer.isBuffer(DataToSend)) {
        DataToSend = DataToSend.toString('hex');
        isbin = true;
    }

    if (!counter)
        counter = 0;
	
	if (!(headers)){
			headers={};
	}

    if (!(data)) {
        data = {
            "host": address,
            "port": port,
            "message": DataToSend,
            "isbin": (isbin ? "true" : "false"),
            //  "expectedreplycount": expectedreplies
        }

    }

    var responsetext = $.ajax({
        type: type,
        url: url,
		headers: headers,
        data: data,
        cache: false,
        async: false,
    }).responseText;

    if (responsetext.indexOf("NOK") === 0) {
        console.log('error from server: ' + responsetext);
        if (callback)
            callback(null, true);
    } else {
        if (isbin) {
            if (callback)
                callback(Buffer.from(responsetext, "hex"));
        } else {
            if (callback)
                callback(responsetext);
        }
    }
    POS.hourGlass.hide();

}

CRunClient.prototype.sendQuery = function (sql, callback, database) {

    var def = jQuery.Deferred();
    var me = this;
    POS.hourGlass.show();

    var errorfunc = function (err) {
        var errstr = "";
        if (err)
            errstr = err;
        if (callback) {
            $.when(callback(null, err)).then(function () {
                def.resolve(true);
            });
        } else {
            def.resolve(true);
        }

        log.add(1, " sendQueryError ", " Connection Error : " + errstr);
        POS.hourGlass.hide();
        var text = "Keine Verbindung zum Server!\nBitte noch einmal oder sp&auml;ter versuchen! ";
        POS.message.show(text, "warning", "OK");
        //def.resolve(true);//error=true
    };
    var to = setTimeout(errorfunc, 15000);

    $.ajax({
        url: "corsproxy.php",
        data: {
            "url": "http://" + POS.UpdateServer + ":" + POS.UpdatePort + "/sql/sql.php",
            "query": sql,
            "db": database,
        },
        cache: false,
        type: "POST",
        success: function (response) {
            clearTimeout(to);
            POS.hourGlass.hide();
            if (response == "") {
                response = [];
            } else if (response.startsWith("NOK")) {
                errorfunc(response);
                return;
            } else {
                response = JSON.parse(response);
            }
            POS.hourGlass.hide();
            var err = null;
            if (callback) {
                $.when(callback(response, err)).then(function () {
                    def.resolve();
                });
            } else {
                def.resolve();
            }
        },
        error: function (xhr) {
            clearTimeout(to);
            errorfunc(xhr.responseText);
            def.resolve(true);
        },
    });

    return def.promise();

}

CRunClient.prototype.sendDataConnected = function (callback, DataToSend, counter, defret, expectedreplies) {

    this.sendData(this.address, this.port, callback, DataToSend, counter, defret, expectedreplies);
    /* var me = this;
    this.callback = callback;
    this.client.write(DataToSend);
     */
}

CRunClient.prototype.endClient = function () {
    //this.client.end();
}

//module.exports.sendData = sendData;
//@ sourceURL=CLS_CRunClient.js

export { CRunClient };
